"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LegacyOverrides = exports.Fonts = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
var _base = require("./base");
const global = {
  'html, body': {
    color: 'text.primary.light'
  },
  // By default, Chakra has all svgs set to 'display: block',
  // this breaks the layout of some older components, so now
  // we set all svgs to 'display: inline-block;' and only set
  // 'display: block;' on the components that need it
  // (as of 3/9/2021 only the v1 AutoSuggestInput component
  // needed this update)
  svg: {
    display: 'inline-block'
  }
};
var _default = exports.default = global;
const Fonts = () => /*#__PURE__*/_react.default.createElement(_react2.Global, {
  styles: `
            @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap');
            /* Copied from https://fonts.googleapis.com/css2?family=Open+Sans:wght@700&display=swap */
            /* latin-ext */
            @font-face {
                font-family: 'Open Sans';
                font-style: normal;
                font-weight: 700;
                src: url(https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UN7rgOXOhpKKSTj5PW.woff2) format('woff2');
                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
            }
            /* latin-ext */
            @font-face {
                font-family: 'Open Sans';
                font-style: normal;
                font-weight: 600;
                src: url(https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UNirkOXOhpKKSTj5PW.woff2) format('woff2');
                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
            }
            /* latin-ext */
            @font-face {
                font-family: 'Open Sans';
                font-style: normal;
                font-weight: 400;
                src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFW50bf8pkAp6a.woff2) format('woff2');
                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
            }
            /* latin-ext */
            @font-face {
                font-family: 'Open Sans';
                font-style: normal;
                font-weight: 300;
                src: url(https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UN_r8OXOhpKKSTj5PW.woff2) format('woff2');
                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
            }
        `
});
exports.Fonts = Fonts;
const LegacyOverrides = ({
  useLegacyOverrides
}) => useLegacyOverrides ? /*#__PURE__*/_react.default.createElement(_react2.Global, {
  styles: `
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            margin-top: 0;
            font-weight: ${_base.fontWeights.semibold};
        }

        .heading-sm {
            font-size: ${_base.fontSizes.base};
        }
        .heading-md {
            font-size: ${_base.fontSizes.md};
        }
        .heading-lg {
            font-size: ${_base.fontSizes['5xl']};
        }

        p {
            line-height: 1.5;
        }

        a {
            outline: none;
            text-align: left;
            color: ${_base.colors.primary.default};
            text-decoration: none;

            &:active,
            &:focus {
                outline: none;
            }

            &:hover {
                color: ${_base.colors.primary['700']};
            }
        }

        small {
            font-size: ${_base.fontSizes.xs};
        }

        `
}) : null;
exports.LegacyOverrides = LegacyOverrides;